/** Themify icon class per normalized menu key (API icon field is ignored for TMS). */
const TMS_ICON_BY_KEY: Record<string, string> = {
    dashboard: "ti-dashboard",
    tmsdashboard: "ti-dashboard",
    generalmaster: "ti-settings",
    tmsgeneralmaster: "ti-settings",
    companyprofile: "ti-briefcase",
    tmscompanyprofile: "ti-briefcase",
    hradmin: "ti-id-badge",
    tmshradmin: "ti-id-badge",
    franchisee: "ti-user",
    tmsfranchisee: "ti-user",
    psa: "ti-support",
    tmspsa: "ti-support",
    hotel: "ti-home",
    tmshotel: "ti-home",
    enquiries: "ti-search",
    tmsenquiries: "ti-search",
    enquiry: "ti-search",
    enquirynow: "ti-search",
    tmsenquirynow: "ti-search",
    bookings: "ti-calendar",
    tmsbookings: "ti-calendar",
    booking: "ti-calendar",
    passport: "ti-book",
    tmspassport: "ti-book",
    visadocuments: "ti-files",
    addenquiry: "ti-plus",
    tmsaddenquiry: "ti-plus",
    enquirylist: "ti-view-list-alt",
    tmsenquirylist: "ti-view-list-alt",
    cancelenquirylist: "ti-na",
    tmscancelenquirylist: "ti-na",
    bookinglist: "ti-view-list-alt",
    tmsbookinglist: "ti-view-list-alt",
    addbooking: "ti-plus",
    tmsaddbooking: "ti-plus",
    region: "ti-world",
    country: "ti-flag",
    state: "ti-map",
    city: "ti-location-pin",
    users: "ti-user",
    user: "ti-user",
    rolemapping: "ti-shield",
    modulepermission: "ti-lock",
    module: "ti-layout",
    suppliers: "ti-truck",
    supplier: "ti-truck",
    campaign: "ti-announcement",
    campaignlist: "ti-view-list-alt",
    campaignbuilder: "ti-settings",
    contact: "ti-email",
    contactlist: "ti-view-list-alt",
    addnewcontact: "ti-plus",
    contactgroup: "ti-agenda",
    package: "ti-package",
    packages: "ti-package",
    proformainvoice: "ti-clipboard",
    quotation: "ti-write",
    report: "ti-bar-chart",
    reports: "ti-bar-chart",
    branch: "ti-location-pin",
    bankmaster: "ti-credit-card",
    taxmaster: "ti-money",
    commission: "ti-wallet",
    commision: "ti-wallet",
    department: "ti-briefcase",
    servicemaster: "ti-settings",
};

const TMS_DEFAULT_FALLBACK_ICON = "ti-layout";

function normalizeKey(value?: string): string {
    return (value || "").toLowerCase().replace(/[\s/_-]+/g, "");
}

function lookupIcon(key: string): string | undefined {
    if (TMS_ICON_BY_KEY[key]) return TMS_ICON_BY_KEY[key];
    const partial = Object.entries(TMS_ICON_BY_KEY).find(
        ([k]) => key.includes(k) || k.includes(key)
    );
    return partial?.[1];
}

/** Resolves a Themify icon class for TMS menus. Ignores API/seed icon strings. */
export function resolveTmsMenuIcon(item: {
    moduleName?: string;
    code?: string;
    moduleCode?: string;
}): string {
    const keys = [item.code, item.moduleCode, item.moduleName]
        .map((v) => normalizeKey(v))
        .filter(Boolean);

    for (const key of keys) {
        const icon = lookupIcon(key);
        if (icon) return icon;
    }
    return TMS_DEFAULT_FALLBACK_ICON;
}

function withResolvedIcons(node: any): any {
    const children = (node.children || []).map(withResolvedIcons);
    return {
        ...node,
        icon: resolveTmsMenuIcon(node),
        children,
    };
}

/** Applies TMS icon classes to an API-driven menu tree. */
export function applyTmsMenuIcons(nodes: any[]): any[] {
    return (nodes || []).map(withResolvedIcons);
}
